import { ApprovalRepository } from "../repositories/ApprovalRepository";

/**
 * Reject Review Use Case
 * Rejects a review request with required comments
 */
export class RejectReviewUseCase {
  constructor(private repository: ApprovalRepository) {}

  async execute(reviewId: number, comments: string): Promise<void> {
    if (!reviewId || reviewId <= 0) {
      throw new Error("Valid review ID is required");
    }

    if (!comments || comments.trim() === "") {
      throw new Error("Comments are required when rejecting a review");
    }

    return await this.repository.rejectReview(reviewId, comments);
  }
}
